
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/anchors/components/anchorVariables.scss.css.virtualfile';
        module.exports = {"anchorHandleWidth":"140px","anchorHandleHeight":"24px","anchorHandleMarginRight":"68px"};